module.exports = __webpack_public_path__ + "static/media/severity5.62c6eb50.png";